import { isPermanentlyHiddenPlacement } from '../../../../../app/shared/navigation/permanentlyHiddenMenus'
import { COASTAL_POSITION_REPORT_ROUTE, DPR_ROUTE } from '../../../../../app/modules/operations/core/routes'

const BACKEND_MENU_ROUTE_MAP: Record<string, string> = {
  // —— Admin ——
  'admin|companies': '/manage/companies',
  'admin|company admin': '/manage/companies',
  'admin|sub-companies': '/manage/subcompanies',
  'admin|company group admin': '/manage/subcompanies',
  'admin|vessels': '/manage/vessels',
  'admin|user management': '/manage/usermanagement',
  'admin|users': '/manage/usermanagement',
  'admin|roles': '/manage/role-permissions',
  'admin|permissions': '/manage/role-permissions',
  'admin|roles and permissions': '/manage/role-permissions',
  'admin|role permissions': '/manage/role-permissions',
  'admin|vendor management': '/manage/vendormanagement',

  // —— Operations ——
  'operations|voyage reports': '/operations/voyages',
  'operations|position reports': '/operations/overview',
  'operations|daily position reports': DPR_ROUTE,
  'operations|cargo operations': '/operations/cargo-operations',
  'operations|library': '/operations/library',
  'operations|in-port consumption report': '/operations/inport-consumption',
  'operations|in port consumption report': '/operations/inport-consumption',
  'operations|off shore report': '/operations/offshore-report',
  'operations|form index': '/operations/form-index',
  'operations|reports': '/operations/reports/kpis',
  'operations|reports|kpis': '/operations/reports/kpis',
  'operations|reports|kpi': '/operations/reports/kpis',
  'operations|reports|assignment': '/operations/reports/kpis',
  'operations|reports|voyage abstract': '/operations/reports/voyage-abstract',
  'operations|reports|menu': '/operations/reports/voyage-abstract',
  'operations|reports|cii summary': '/operations/reports/cii-summary',
  'operations|reports|template': '/operations/reports/cii-summary',
  'operations|reports|cargo plan log': '/operations/reports/cargo-plan-log',
  'operations|reports|submenu': '/operations/reports/cargo-plan-log',
  'operations|reports|field': '/operations/reports/cargo-plan-log',
  'operations|defects list': '/operations/defects-list',
  'operations|daily position report': DPR_ROUTE,

  'operations|daily movement report': DPR_ROUTE,
  'operations|daily movement reports': DPR_ROUTE,
  'operations|daily progress reports': DPR_ROUTE,
  'operations|daily progress report': DPR_ROUTE,
  'operations|coastal position reports': COASTAL_POSITION_REPORT_ROUTE,

  // —— Crewing ——
  'crewing|crew master': '/crewingtest/crewinglist',
  'crewing|crew management': '/crewingtest/crewinglist',
  'crewing|crew assignment': '/crewing/assignment',
  'crewing|crew list': '/crewingtest/crewinglist',
  'crewing|crew onboard': '/crewingtest/crewinglist',
  'crewing|signing': '/crewingtest/crewinglist',
  'crewing|rest hours': '/crewingtest/resthours',
  'crewing|rest hour management': '/crewingtest/resthours',
  'crewing|crew resthours and overtime': '/crewingtest/resthours',
  'crewing|crew rest hours and overtime': '/crewing/resthours',
  'crewing|workhours': '/crewing/resthours',
  'crewing|crew resthours and overtime|rest hour management': '/crewingtest/resthours',
  'crewing|crew resthours and overtime|crew overtime': '/crewing/crewovertime',
  'crewing|crew resthours and overtime|overtime entry': '/crewing/crewovertime',
  'crewing|overtime': '/crewing/crewovertime',
  'crewing|crew overtime': '/crewing/crewovertime',
  'crewing|crew deduction': '/crewing/crewdeductions',
  'crewing|wages portage': '/crewing/crewdeductions',
  'crewing|crew claims and reimbursement': '/crewing/crewclaims',
  'crewing|claims': '/crewing/crewclaims',
  'crewing|crew allotment and advance': '/crewing/crewallotment',
  'crewing|allotment advances': '/crewing/crewallotment',
  'crewing|crew appraisal': '/crewing/appraisal',
  'crewing|appraisal': '/crewing/appraisal',
  'crewing|crew training test and verification': '/crewing/crewtraining',
  'crewing|training': '/crewing/crewtraining',
  'crewing|crew complaints': '/crewing/crewcomplaints',

  // —— Crewingtest (/crewingtest/*) —— extended crew shell; parallel keys to Crewing where labels match the API
  'crewingtest|crew master': '/crewingtest/crewinglist',
  'crewingtest|crew management': '/crewingtest/crewinglist',
  'crewingtest|crew list overview': '/crewingtest/crewinglist',
  'crewingtest|crew assignment': '/crewingtest/assignment',
  'crewingtest|crew list': '/crewingtest/crewdetails',
  'crewingtest|crew onboard': '/crewingtest/signing',
  'crewingtest|signing': '/crewingtest/signing',
  'crewingtest|rest hours': '/crewingtest/resthours',
  'crewingtest|crew resthours and overtime': '/crewingtest/resthours',
  'crewingtest|crew rest hours and overtime': '/crewingtest/resthours',
  'crewingtest|workhours': '/crewingtest/resthours',
  'crewingtest|crew resthours and overtime|rest hour management': '/crewingtest/resthours',
  'crewingtest|crew resthours and overtime|crew overtime': '/crewingtest/crewovertime',
  'crewingtest|crew resthours and overtime|overtime entry': '/crewingtest/crewovertime',
  'crewingtest|overtime': '/crewingtest/crewovertime',
  'crewingtest|crew overtime': '/crewingtest/crewovertime',
  'crewingtest|wages portage': '/crewingtest/portagebill',
  'crewingtest|wages / portage': '/crewingtest/portagebill',
  'crewingtest|crew deduction': '/crewingtest/deductions',
  'crewingtest|claims': '/crewingtest/reimbursement',
  'crewingtest|crew claims and reimbursement': '/crewingtest/reimbursement',
  'crewingtest|allotment advances': '/crewingtest/crewallotment',
  'crewingtest|allotment / advances': '/crewingtest/crewallotment',
  'crewingtest|crew appraisal': '/crewingtest/appraisal',
  'crewingtest|appraisal': '/crewingtest/appraisal',
  'crewingtest|crew training test and verification': '/crewingtest/crewtraining',
  'crewingtest|training': '/crewingtest/crewtraining',
  'crewingtest|crew complaints': '/crewingtest/crewcomplaints',
  'crewingtest|crew wages and portage bills': '/crewingtest/portagebill',
  'crewingtest|crew wages and portage bills|portage bill workspace': '/crewingtest/portagebill',
  'crewingtest|crew wages and portage bills|wage snapshot': '/crewingtest/wagesnapshot',
  'crewingtest|crew wages and portage bills|adjustments / allowances': '/crewingtest/adjustments',
  'crewingtest|crew wages and portage bills|adjustments allowances': '/crewingtest/adjustments',
  'crewingtest|crew wages and portage bills|deductions manager': '/crewingtest/deductions',
  'crewingtest|crew wages and portage bills|reimbursements manager': '/crewingtest/reimbursement',
  'crewingtest|crew wages and portage bills|allotment & bank details': '/crewingtest/crewallotment',
  'crewingtest|crew wages and portage bills|allotment bank details': '/crewingtest/crewallotment',

  // —— Technical ——
  'technical|machinery': '/technical/machinery',
  'technical|pms': '/technical/pms/dashboard',
  'technical|pms|dashboard': '/technical/pms/dashboard',
  'technical|pms|jobs': '/technical/pms/jobs',
  'technical|pms|pms jobs': '/technical/pms/jobs',
  'technical|pms|running hours': '/technical/pms/running-hours',
  'technical|pms|calendar planning': '/technical/pms/calendar-planning',
  'technical|pms|plans': '/technical/pms/plans',
  'technical|pms|templates': '/technical/pms/templates',
  'technical|monthly log': '/technical/monthly-log',
  'technical|procurement': '/procurement/overview',
  'technical|procurement|overview': '/procurement/overview',
  'technical|procurement|requisitions': '/procurement/requisition',
  'technical|procurement|rfq management': '/procurement/rfq-management',
  'technical|procurement|quotation management': '/procurement/quotation-management',
  'technical|procurement|purchase orders': '/procurement/purchase-orders',
  'technical|procurement|company po info': '/procurement/company-po-info',
  'technical|procurement|delivery tracking': '/procurement/delivery-tracking',
  'technical|procurement|procurement trail': '/procurement/delivery-tracking',
  'technical|procurement|goods receipt': '/procurement/goods-receipt',
  'technical|procurement|invoice management': '/procurement/invoice-management',
  'technical|procurement|audit trail': '/procurement/audit-trail',
  'technical|procurement|user management': '/procurement/user-management',
  'technical|defects list': '/technical/defects-list',

  // Standalone Procurement module (if ACL still emits it — layout prefers Technical subtree)
  'procurement|requisitions': '/procurement/requisition',
  'procurement|rfq management': '/procurement/rfq-management',
  'procurement|quotation management': '/procurement/quotation-management',
  'procurement|purchase orders': '/procurement/purchase-orders',
  'procurement|goods receipt': '/procurement/goods-receipt',
  'procurement|invoice management': '/procurement/invoice-management',
  'procurement|delivery tracking': '/procurement/delivery-tracking',
  'procurement|procurement trail': '/procurement/delivery-tracking',
  'procurement|vendor library': '/procurement/inventory-management',
  'procurement|procurement libraries': '/procurement/inventory-management',
  'procurement|overview': '/procurement/overview',

  // —— QHSE ——
  'qhse|document library': '/qhse/document-library',
  'qhse|static templates': '/qhse/forms-checklists/library',
  'qhse|forms and checklists': '/qhse/forms-checklists/submissions',
  'qhse|forms and checklists|submissions': '/qhse/forms-checklists/submissions',
  'qhse|forms and checklists|library': '/qhse/forms-checklists/library',
  'qhse|forms and checklists|static templates': '/qhse/forms-checklists/library',
  'qhse|forms and checklists|work permits and checklists': '/qhse/work-permits-and-checklists',
  'qhse|forms and checklists|work permits': '/qhse/work-permits-and-checklists',
  'qhse|forms and checklists|office certificates': '/qhse/office-certificates',
  'qhse|forms and checklists|vessel certificates': '/qhse/vessel-certificates',
  'qhse|forms and checklists|manuals and plans': '/qhse/manuals-and-plans',
  'qhse|forms and checklists|defects list': '/qhse/defects-list',
  'qhse|forms and checklists|near miss reports': '/qhse/accident-near-miss-reports',
  'qhse|forms and checklists|near miss': '/qhse/accident-near-miss-reports',
  'qhse|forms and checklists|safety committee meeting': '/qhse/safety-committee-meeting',
  'qhse|forms and checklists|safety committee': '/qhse/safety-committee-meeting',
  'qhse|forms and checklists|risk assessment library': '/qhse/risk-assessment',
  'qhse|forms and checklists|risk assessment form': '/qhse/risk-assessment',
  'qhse|forms and checklists|risk assessment': '/qhse/risk-assessment',
  'qhse|vessel certificates': '/qhse/vessel-certificates',
  'qhse|office certificates': '/qhse/office-certificates',
  'qhse|manuals and plans': '/qhse/manuals-and-plans',
  'qhse|defects list': '/qhse/defects-list',
  'qhse|audits and inspection': '/qhse/audit-index',
  'qhse|audits and inspection|audit index': '/qhse/audit-index',
  'qhse|audits and inspection|inspection index': '/qhse/inspindex',
  'qhse|audits and inspection|audit planning': '/qhse/audit-planning',
  'qhse|audits and inspection|inspection planning': '/qhse/insplanning',
  'qhse|audits and inspection|audit findings': '/qhse/audit-findings',
  'qhse|audits and inspection|inspection findings': '/qhse/inspection-findings',
  'qhse|vessel audits': '/qhse/audit-index',
  'qhse|vessel audits|audit index': '/qhse/audit-index',
  'qhse|vessel audits|audit planning': '/qhse/audit-planning',
  'qhse|vessel audits|audit findings': '/qhse/audit-findings',
  'qhse|audit': '/qhse/audit-index',
  'qhse|audit|audit index': '/qhse/audit-index',

  'qhse|vessel inspection': '/qhse/inspindex',
  'qhse|vessel inspection|inspection index': '/qhse/inspindex',
  'qhse|vessel inspection|inspection planning': '/qhse/insplanning',
  'qhse|vessel inspection|inspection findings': '/qhse/inspection-findings',

  'qhse|near miss reports': '/qhse/accident-near-miss-reports',
  'qhse|near miss': '/qhse/accident-near-miss-reports',
  'qhse|risk assessment library': '/qhse/risk-assessment',
  'qhse|risk assessment form': '/qhse/risk-assessment',
  'qhse|risk assessment': '/qhse/risk-assessment',
  'qhse|safety committee meeting': '/qhse/safety-committee-meeting',
  'qhse|safety committee': '/qhse/safety-committee-meeting',
  'qhse|work permits and checklists': '/qhse/work-permits-and-checklists',
  'qhse|work permits': '/qhse/work-permits-and-checklists',
  'qhse|month end library': '/qhse/month-end-reports',
  'qhse|month end library|main engine consumption': '/qhse/month-end-reports',
  'qhse|month end library|machinery status': '/qhse/month-end-reports',
  'qhse|month end library|months end report': '/qhse/month-end-reports',
  'qhse|month end reports': '/qhse/month-end-reports',
  'qhse|month end reports|main engine consumption': '/qhse/month-end-reports',
  'qhse|month end reports|machinery status': '/qhse/month-end-reports',
  'qhse|month end reports|months end report': '/qhse/month-end-reports',
  'qhse|emergency drills': '/qhse/emergency-drills/planner',
  'qhse|emergency drills|drill planner': '/qhse/emergency-drills/planner',
  'qhse|emergency drills|emergency drill report': '/qhse/emergency-drills/report',
  'qhse|emergency drills|emergency drill review': '/qhse/emergency-drills/review',

  // —— Accounts —— (static fallback module; often a single landing route)
  'accounts|accounts': '/accounts',
}

const LABEL_ALIASES: Record<string, string> = {
  'sub companies': 'company group admin',
  'sub-companies': 'company group admin',
  'company group admins': 'company group admin',
  'company group admin': 'company group admin',
  users: 'user management',
  grn: 'goods receipt',
  invoices: 'invoice management',
  'manuals & plans': 'manuals and plans',
  certificates: 'vessel certificates',
  'inspection finding index': 'inspection findings',
  'inspection finding': 'inspection findings',
  rfq: 'rfq management',
  'procurement trail': 'delivery tracking',
  'risk assessment library': 'risk assessment form',
  'month end library': 'month end reports',
  'wages / portage': 'crew deduction',
  'allotment / advances': 'crew allotment and advance',
  'technical defects': 'defects list',
  'daily position report': 'daily progress reports',
  'daily position reports': 'daily progress reports',
  'daily movement report': 'daily progress reports',
  'daily movement reports': 'daily progress reports',

}

export const normalizeBackendLabel = (value: string): string =>
  String(value || '')
    .toLowerCase()
    .trim()
    .replace(/&/g, ' and ')
    .replace(/[^\w\s-]/g, ' ')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\s+\((?:remove|legacy)\)\s*$/i, '')
    .trim()

const canonicalLabel = (value: string): string => {
  const normalized = normalizeBackendLabel(value)
  if (!normalized) return normalized
  return LABEL_ALIASES[normalized] || normalized
}

const keyFromParts = (moduleName: string, menuName?: string | null, subMenuName?: string | null): string =>
  [moduleName, menuName, subMenuName]
    .filter((x): x is string => Boolean(x && x.trim()))
    .map((x) => canonicalLabel(x))
    .join('|')

export const resolveBackendMenuRoute = (
  moduleName: string,
  menuName?: string | null,
  subMenuName?: string | null
): {route: string | null; keyTried: string[]} => {
  if (isPermanentlyHiddenPlacement(moduleName, menuName, subMenuName)) {
    return {route: null, keyTried: []}
  }

  const keys = [
    keyFromParts(moduleName, menuName, subMenuName),
    keyFromParts(moduleName, menuName),
    keyFromParts(moduleName),
  ].filter((k) => k.length > 0)

  for (const key of keys) {
    const mapped = BACKEND_MENU_ROUTE_MAP[key]
    if (mapped) return {route: mapped, keyTried: keys}
  }
  return {route: null, keyTried: keys}
}

export const getBackendMenuRouteMap = (): Record<string, string> => ({...BACKEND_MENU_ROUTE_MAP})
